/**
 * IBEX Navigation — ibex-nav.js
 * Version: 1.0
 *
 * Handles:
 *   1. Click-toggle for PRODUCTS Mega Menu
 *   2. Click-toggle for SUPPORT / ABOUT simple dropdowns
 *   3. Left-column hover → update Featured panel
 *   4. Click-outside to close all panels
 *   5. Mobile hamburger + accordion sub-menus
 *   6. Keyboard accessibility (Escape to close)
 */

(function () {
  'use strict';

  /* ── Featured Data ────────────────────────────────────────── */
  // All entries point to Nova 6 until category-specific products
  // are ready. Update the relevant entry here — no structural change needed.
  const megaMenuData = {
    'battery-wireless': {
      image: '',           // Replace with real image URL when available
      name: 'Nova 6',
      tags: ['RGBAW+UV', 'IP65', 'Digital Zoom', 'AirDMX'],
      url: '/products/nova6-blk-1',
      cta: 'SHOP NOVA 6'
    },
    'moving-heads': {
      image: '',
      name: 'Nova 6',
      tags: ['RGBAW+UV', 'IP65', 'Digital Zoom', 'AirDMX'],
      url: '/products/nova6-blk-1',
      cta: 'SHOP NOVA 6'
    },
    'tubes-bars': {
      image: '',
      name: 'Nova 6',
      tags: ['RGBAW+UV', 'IP65', 'Digital Zoom', 'AirDMX'],
      url: '/products/nova6-blk-1',
      cta: 'SHOP NOVA 6'
    },
    'controllers': {
      image: '',
      name: 'Nova 6',
      tags: ['RGBAW+UV', 'IP65', 'Digital Zoom', 'AirDMX'],
      url: '/products/nova6-blk-1',
      cta: 'SHOP NOVA 6'
    },
    'special-effects': {
      image: '',
      name: 'Nova 6',
      tags: ['RGBAW+UV', 'IP65', 'Digital Zoom', 'AirDMX'],
      url: '/products/nova6-blk-1',
      cta: 'SHOP NOVA 6'
    },
    'accessories': {
      image: '',
      name: 'Nova 6',
      tags: ['RGBAW+UV', 'IP65', 'Digital Zoom', 'AirDMX'],
      url: '/products/nova6-blk-1',
      cta: 'SHOP NOVA 6'
    }
  };

  /* ── State ────────────────────────────────────────────────── */
  let openPanel = null; // 'mega' | 'support' | 'about' | null

  /* ── DOM Refs ─────────────────────────────────────────────── */
  const nav           = document.querySelector('.ibex-nav');
  const megaPanel     = document.getElementById('ibex-mega-panel');
  const megaToggle    = document.getElementById('ibex-products-toggle');
  const categoryItems = document.querySelectorAll('.ibex-nav__category-item');

  const featuredImg   = document.getElementById('ibex-featured-img');
  const featuredName  = document.getElementById('ibex-featured-name');
  const featuredTags  = document.getElementById('ibex-featured-tags');
  const featuredLink  = document.getElementById('ibex-featured-link');
  const featuredCta   = document.getElementById('ibex-featured-cta');

  // Simple dropdowns
  const dropdownToggles = document.querySelectorAll('[data-ibex-dropdown]');

  // Mobile
  const hamburger      = document.getElementById('ibex-hamburger');
  const mobilePanel    = document.getElementById('ibex-mobile-panel');
  const mobileToggles  = document.querySelectorAll('[data-ibex-mobile-toggle]');

  /* ── Helpers ──────────────────────────────────────────────── */
  function closeAll() {
    // Mega
    if (megaPanel) {
      megaPanel.classList.remove('ibex-nav__mega--open');
      if (megaToggle) megaToggle.setAttribute('aria-expanded', 'false');
    }
    // Dropdowns
    document.querySelectorAll('.ibex-nav__dropdown--open').forEach(el => {
      el.classList.remove('ibex-nav__dropdown--open');
    });
    document.querySelectorAll('.ibex-nav__link--active[data-ibex-dropdown]').forEach(el => {
      el.classList.remove('ibex-nav__link--active');
      el.setAttribute('aria-expanded', 'false');
    });
    openPanel = null;
  }

  function openMega() {
    closeAll();
    megaPanel.classList.add('ibex-nav__mega--open');
    megaToggle.setAttribute('aria-expanded', 'true');
    openPanel = 'mega';
  }

  function closeMega() {
    megaPanel.classList.remove('ibex-nav__mega--open');
    megaToggle.setAttribute('aria-expanded', 'false');
    openPanel = null;
  }

  /* ── Featured Panel Update ────────────────────────────────── */
  function updateFeatured(categoryKey) {
    const data = megaMenuData[categoryKey];
    if (!data) return;

    // Image
    if (featuredImg) {
      if (data.image) {
        featuredImg.src = data.image;
        featuredImg.alt = data.name;
        featuredImg.style.display = 'block';
        featuredImg.parentElement.classList.remove('ibex-nav__featured-img-wrap--placeholder');
      } else {
        featuredImg.style.display = 'none';
        featuredImg.parentElement.classList.add('ibex-nav__featured-img-wrap--placeholder');
      }
    }

    // Name
    if (featuredName) featuredName.textContent = data.name;

    // Tags
    if (featuredTags) {
      featuredTags.innerHTML = data.tags
        .map(t => `<span class="ibex-nav__tag">${t}</span>`)
        .join('');
    }

    // Link href
    if (featuredLink) featuredLink.href = data.url;

    // CTA
    if (featuredCta) {
      featuredCta.textContent = data.cta + ' →';
      featuredCta.href = data.url;
    }
  }

  /* ── Category Hover / Click ───────────────────────────────── */
  function activateCategory(item) {
    categoryItems.forEach(ci => ci.classList.remove('ibex-nav__category-item--active'));
    item.classList.add('ibex-nav__category-item--active');
    const key = item.dataset.ibexCategory;
    if (key) updateFeatured(key);
  }

  categoryItems.forEach(item => {
    item.addEventListener('mouseenter', () => activateCategory(item));
    // Also handle click for touch/keyboard users
    item.addEventListener('click', () => activateCategory(item));
  });

  /* ── Mega Menu Toggle ─────────────────────────────────────── */
  if (megaToggle && megaPanel) {
    megaToggle.addEventListener('click', e => {
      e.stopPropagation();
      if (openPanel === 'mega') {
        closeMega();
      } else {
        openMega();
      }
    });
  }

  /* ── Simple Dropdowns ─────────────────────────────────────── */
  dropdownToggles.forEach(toggle => {
    toggle.addEventListener('click', e => {
      e.stopPropagation();
      const targetId  = toggle.dataset.ibexDropdown;
      const dropdown  = document.getElementById(targetId);
      if (!dropdown) return;

      const isOpen = dropdown.classList.contains('ibex-nav__dropdown--open');

      closeAll();

      if (!isOpen) {
        dropdown.classList.add('ibex-nav__dropdown--open');
        toggle.setAttribute('aria-expanded', 'true');
        toggle.classList.add('ibex-nav__link--active');
        openPanel = targetId;
      }
    });
  });

  /* ── Click Outside ────────────────────────────────────────── */
  document.addEventListener('click', e => {
    if (nav && !nav.contains(e.target)) {
      closeAll();
    }
  });

  /* ── Keyboard: Escape ─────────────────────────────────────── */
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && openPanel) {
      closeAll();
      // Return focus to the toggle that opened the panel
      if (megaToggle) megaToggle.focus();
    }
  });

  /* ── Mobile Hamburger ─────────────────────────────────────── */
  if (hamburger && mobilePanel) {
    hamburger.addEventListener('click', () => {
      const isOpen = mobilePanel.classList.contains('ibex-nav__mobile-panel--open');
      if (isOpen) {
        mobilePanel.classList.remove('ibex-nav__mobile-panel--open');
        hamburger.classList.remove('ibex-nav__hamburger--open');
        hamburger.setAttribute('aria-expanded', 'false');
        hamburger.setAttribute('aria-label', 'Open menu');
      } else {
        mobilePanel.classList.add('ibex-nav__mobile-panel--open');
        hamburger.classList.add('ibex-nav__hamburger--open');
        hamburger.setAttribute('aria-expanded', 'true');
        hamburger.setAttribute('aria-label', 'Close menu');
      }
    });
  }

  /* ── Mobile Accordion Sub-Menus ──────────────────────────── */
  mobileToggles.forEach(toggle => {
    toggle.addEventListener('click', () => {
      const targetId = toggle.dataset.ibexMobileToggle;
      const sub = document.getElementById(targetId);
      if (!sub) return;

      const isOpen = sub.classList.contains('ibex-nav__mobile-sub--open');

      // Close all other open sub-menus
      document.querySelectorAll('.ibex-nav__mobile-sub--open').forEach(s => {
        s.classList.remove('ibex-nav__mobile-sub--open');
      });
      document.querySelectorAll('[data-ibex-mobile-toggle][aria-expanded="true"]').forEach(t => {
        t.setAttribute('aria-expanded', 'false');
      });

      if (!isOpen) {
        sub.classList.add('ibex-nav__mobile-sub--open');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ── Init: activate first category ───────────────────────── */
  if (categoryItems.length > 0) {
    activateCategory(categoryItems[0]);
  }

})();
